module.exports = __webpack_public_path__ + "static/media/top-nerds@2x.90bfcd65.png";